import { render, staticRenderFns } from "./WakaNotification.vue?vue&type=template&id=c4c7306e&"
import script from "./WakaNotification.vue?vue&type=script&lang=js&"
export * from "./WakaNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports